/**
 * EmptyState — shown when there is nothing to display: an empty cart, no
 * search results, no orders yet.
 *
 * WHY IT MATTERS: an empty screen looks broken. A good empty state explains
 * WHY it is empty and offers the next step ("Browse products"), which turns a
 * dead end into a path forward. Every list in the app reuses this.
 */

import { cn } from '@/lib/cn';

export function EmptyState({ icon: Icon, title, description, action, className }) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center px-6 py-16 text-center', className)}
    >
      {Icon && (
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-600">
          <Icon size={30} strokeWidth={1.75} />
        </div>
      )}
      <h3 className="text-lg font-semibold text-ink">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-sm text-muted">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export default EmptyState;
